// @flow

import React from 'react';

function base(Type, props, style) {
  let typeProps = Object.assign({}, props);
  let className = props.className || '';
  className += ` btn ${style}`;

  if (typeProps.className) {
    delete typeProps.className;
  }

  return <Type {...typeProps} className={className}>
    {props.children}
  </Type>;
}

function link(props, style) {
  return base('a', props, style);
}

function button(props, style) {
  return base('button', props, style);
}

export class PrimaryLink extends React.Component<any> {
  render() {
    return link(this.props, 'theme-btn');
  }
}

export class PrimaryBtn extends React.Component<any> {
  render() {
    return button(this.props, 'theme-btn');
  }
}

export class PrimaryAlternateLink extends React.Component<any> {
  render() {
    let style = {
      backgroundColor: 'transparent'
    };

    let newProps = Object.assign({}, this.props, { style });

    return link(newProps, 'outline-btn');
  }
}

export class PrimaryAlternateBtn extends React.Component<any> {
  render() {
    let style = {
      backgroundColor: 'transparent'
    };

    let newProps = Object.assign({}, this.props, { style });

    return button(newProps, 'outline-btn');
  }
}

export class SecondaryLink extends React.Component<any> {
  render() {
    return link(this.props, 'text-btn');
  }
}

export class SecondaryBtn extends React.Component<any> {
  render() {
    return button(this.props, 'text-btn');
  }
}

export class DonateLink extends React.Component<any> {
  render() {
    return link(this.props, 'support-btn');
  }
}

export class DonateBtn extends React.Component<any> {
  render() {
    return button(this.props, 'support-btn');
  }
}

export class DisabledLink extends React.Component<any> {
  render() {
    return link(this.props, 'disabled-btn');
  }
}

export class DisabledBtn extends React.Component<any> {
  render() {
    let props = Object.assign({}, this.props, { disabled: 'disabled' });
    return button(props, 'disabled-btn');
  }
}